<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-tabs>
          <v-tab v-for="tab in tabItems" :key="tab.to.name" :to="tab.to">{{ tab.title }}</v-tab>
        </v-tabs>
        <router-view></router-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    tabItems(){
      let items = []

      if (this.isUserManager) {
        items.push({
          to: {
            name: 'teacherReport',
            params: {
              period: this.period
            }
          },
          title: 'Все преподаватели'
        })
      }

      if (this.isUserHead) {
        items.push({
          to: {
            name: 'teacherReportByDepartment',
            params: {
              period: this.period
            }
          },
          title: 'Преподаватели кафедры'
        })
      }

      if (this.isUserSuperManager || this.isUserHead) {
        items.push({
          to: {
            name: 'reportsTeachersSummary',
            params: {
              period: this.period
            }
          },
          title: 'Сводная ведомость'
        })
        items.push({
          to: {
            name: 'reportsDepartmentSummary',
            params: {
              period: this.period
            }
          },
          title: 'Показатели кафедр'
        })
      }

      if (this.isUserSuperManager) {
        items.push({
          to: {
            name: 'reportsNonCounted',
            params: {
              period: this.period,
            }
          },
          title: 'Не проверенные'
        })
      }

      return items
    },
    period () {
      return this.$route.params.period
    },
    isUserManager() {
      return this.$store.getters.isUserManager
    },
    isUserSuperManager () {
      return this.$store.getters.isUserSuperManager
    },
    isUserHead () {
      return this.$store.getters.isUserHead
    }
  },
  mounted () {
    if (this.$route.name === 'periodReports') {
      this.$router.push(this.tabItems[0].to)
    }
  },

  methods: {}
}
</script>
